<template>
  <div class="joinus-container">
    <module1 />
    <module2 ref="join2"/>
    <module3 ref="join3"/>
    <module4 ref="join4" />
    <module5 ref="join5"/>
  </div>
</template>

<script>
import module1 from "./module1.vue";
import module2 from "./module2.vue";
import module3 from "./module3.vue";
import module4 from "./module4.vue";
import module5 from "./module5.vue";
import {EventBus} from "@/utils/bus";
import {handleScrollToForm} from "@/utils/scrollUtils";
export default {
  name: "JoinUsPage",
  components: {
    module1,
    module2,
    module3,
    module4,
    module5,
  },data(){
        return{
            scrollTimeout: null
        }
    }
    ,methods:{

    },mounted() {
        EventBus.$on('scroll-to-join', (sectionId) => handleScrollToForm(this,sectionId))
        if(this.$route.query.section){
            handleScrollToForm(this,this.$route.query.section);
        }
    },
    beforeDestroy() {
        // 移除监听器防止内存泄漏
        EventBus.$off('scroll-to-join', handleScrollToForm)

    }
};
</script>

<style scoped>
.joinus-container {
  display: flex;
  flex-direction: column;
}
</style>
